import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  requestRelatedPhasesRequest,
  requestRelatedPhasesSuccess,
  requestRelatedPhasesFailure,
} = createActions({
  REQUEST_RELATED_PHASES_SUCCESS: (json, phaseId) => ({
    relatedPhases: json.related_phases,
    phaseId,
  }),
}, 'REQUEST_RELATED_PHASES_REQUEST', 'REQUEST_RELATED_PHASES_FAILURE');

export function requestRelatedPhases(phaseId) {
  return (dispatch) => {
    dispatch(requestRelatedPhasesRequest());

    return request(`phases/${phaseId}/related_phases`)
      .then(({ json }) =>
        dispatch(requestRelatedPhasesSuccess(json, phaseId)),
      )
      .catch(error => dispatch(requestRelatedPhasesFailure(error)));
  };
}

const {
  createRelatedPhaseRequest,
  createRelatedPhaseSuccess,
  createRelatedPhaseFailure,
} = createActions({
  CREATE_RELATED_PHASE_SUCCESS: (json, phaseId) => ({
    relatedPhase: json.related_phase,
    phase: json.meta.phase,
    phaseId,
  }),
}, 'CREATE_RELATED_PHASE_REQUEST', 'CREATE_RELATED_PHASE_FAILURE');

export function createRelatedPhase(phaseId, relatedPhaseId) {
  return (dispatch) => {
    dispatch(createRelatedPhaseRequest());

    const req = { method: 'POST', body: { related_phase_id: relatedPhaseId } };
    return request(`phases/${phaseId}/related_phases`, req)
      .then(({ json }) =>
        dispatch(createRelatedPhaseSuccess(json, phaseId)),
      )
      .catch(error => dispatch(createRelatedPhaseFailure(error)));
  };
}

const {
  removeRelatedPhaseRequest,
  removeRelatedPhaseSuccess,
  removeRelatedPhaseFailure,
} = createActions({
  REMOVE_RELATED_PHASE_SUCCESS: (json, relatedPhaseId) => ({
    message: json.message,
    relatedPhaseId,
  }),
}, 'REMOVE_RELATED_PHASE_REQUEST', 'REMOVE_RELATED_PHASE_FAILURE');

export function removeRelatedPhase(phaseId, relatedPhaseId) {
  return (dispatch) => {
    dispatch(removeRelatedPhaseRequest());

    const req = { method: 'DELETE' };
    return request(`phases/${phaseId}/related_phases/${relatedPhaseId}`, req)
      .then(({ json }) =>
        dispatch(removeRelatedPhaseSuccess(json, relatedPhaseId)),
      )
      .catch(error => dispatch(removeRelatedPhaseFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/related_phases.js